import React, { useState, useEffect } from 'react';
import '../../screens/logging/logging.css';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import 'react-toastify/dist/ReactToastify.css';
import { DataGridPro, useGridApiContext, useGridApiRef } from '@mui/x-data-grid-pro';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import licenceIcon from '../../assets/module-icons/ic_licence.png';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

function CustomEditComponent(props) {
    const { id, field, value } = props;
    const apiRef = useGridApiContext();
  
    const handleValueChange = (event) => {
        const newValue = event.target.value; 
        apiRef.current.setEditCellValue({ id, field, value: newValue });
    };

    const saveValueChange = () => {
        if (window.confirm("Save changes?") === true) {
            try{
                let postData = {id: props.row.cust_no, field: props.sql, value: value, user_id: props.user, sft: props.login?.sft_status};
                SftGlobalData.post('logging&action=updateCustomer', postData).then(response => {
                    props.reload();
                });
            } catch(e){
                console.error(e);
            }
        } else {
            apiRef.current.setEditCellValue({ id, field, value: props.orig });
        }
    }

    const handleEnter = (e) => {
        if(e.keyCode === 13){
            saveValueChange();
        }
    }
  
    return <input type="text" value={value} onChange={handleValueChange} onKeyDown={(event)=>{handleEnter(event);}} onBlur={()=>{saveValueChange()}}/>;
  }

const CustomersTable = (props) =>  {
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const gridColumns = [
        {
            field: 'logo',
            headerName: props.t('logo'),
            headerClassName: 'bold',
            minWidth: 50,
            maxWidth: 50,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return <img alt="Logo" loading="lazy" width="32" src={(params.row.logo !== "" ? params.row.logo : "data:image/bmp;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAH3klEQVR4nO2aW3AT5xmGn10dvJItO7YkWwJMWmrDQIkJBdq0hKYGBhISesEU2oYZErhpbjrTNtNctL3IXafTu7TD9KIDnU4LFFKaaabBpsAMsem0CceQcHTCQWCtLR9kybZkS7t/L2TJtg62TsgG+73T/of9nvf//sPuCuY1r3nNZUkzHcCj0m/f+HOtbNQ+QJJCb/7u9Q2Z6smlDKpUisHrp4E1CJSp6hpLFFPJ9M6PDzgjQjsFrARuaLrYPlX9J2oKxOCl08AzwA1Np/mt/XvVqdo8MQbkAw9PiAH5wsMTYEAh8JDGgLdfP6jYbPwawQ8AVxFjnUl5JaQjgUHxi7f/tDc8sSBlFxiD/0npYiuJ3ALxU5sNAbw5sSB1G4yNPA2vbsXqspcmvDSqthiosRgSv/tCGv0hDQAtFObzY2cI9/ixOat4ft+LKDZLoq6uw8NghFFNADDs7aHj8ElkWd5DkgHpDkIuYFbB9+cAryXBAyxcUgeArumO5HsV7STYcaiVjsMnC+4n3cj35TDynUnwyf0lK6+TYO+VWyDJ2JsaEteG1d6Uemr7FQQC9/PPZtVvoSOfKzzkaYD6n6tooRHKqiupqK9NWyfQ8YDujz5DNplwfasJSZ462dLBZzvy+cJDnlOg5qtLAPCevZi4ZnXZsbrHp5h67goAtV9fPmvhIYcM0KMasjHWad1zKxno8KBr0UR5w6tbJ9WXjEbK3U4ca5YnrglNQ5INk04fMwkPWRrQc+Em3vbLOFYvpe65lchmE8v2vgIic5vG3eOGaOER1HNX6b16G8eqRhY0r00bbK5bXaHwkEMGCE3Dd/46A7fus+y1l5FMRpAgeE/Fd/4aw95e0HUUx1PYVzVQveIrIIEQOrf+0kIkMAQSlFVXpg22FAte3gY41izDXFWOt+3ypPTt/vg6avslJAlqHGA0QU9XH57W/xG818Xil76JhISp3IKpwsKCF76G1e2Y8bTP2QCAyoZFVDYsSvwe7vShtl+isgq+u0uj1h0LKBiAf/3dROeNu5QvcGJ/tpGGH27JGOxMwkMBB6GeS7dAwLYd4/AAtkrYvjOCWZHpuXhjUpvZBg9ZZEDHodbEIcfqdiRGc7irj/IKWFCfuhKWV8DCep07t4NokQgGk4k7R1r5pDPWT029k6Y9L844PBSQAdI0bxLE2GIhEQvWKI83iOpiVsBDFhmQvL/HZamrwX8jyMP7EgsXT86CoUF4eB/Kqm3YKxVqLAa+88YrwOxI+4nKOwPsq5eCBB8cN9DlHR/d4AD886iRyIhg8TeWz4o5H99e0ynrXWDQ0433w4vokSiNu7dS7nbi3rAab9slDv3RkNgGfaqErgnqVi5h5foVk4KYKfi+Qg3o/eQ2D099DMTO/PGzvXPtcix1NfjOX8Pf2Yuu61hqn2LxumUsX9eYODPMVnjIIQNM5QqOtStwrF46/nAjoKK+jor6uozBzmZ4yNIAe1Mj9qbGxG89qvH54VYkg2HSIllK+NHQCABmS1lKWbbwkOf7gJ4L1wn5/Cj2qsS1O0daeWCQeeFHL6cEUUz40aEwF46fQ73pAcC1rJ41O9ZjLldS7puNct4FhK7T/dG12M3Xr0oEG+zspc/jSwmi2PBtB1pRb3qQFSOyYkC96aHtQCujQ+Gc4SGPDJBkGfuqRgyWMiobFpUs7UeHwrQfbCXQ1Y/JYcWz0QTAwjMjBLr6OXughad3bMRgmfJjcIryOge4v72a2nUrJgVbvchB5ULHIx35AbUfk9PK/Y1GNEVCUyQ8m8vAoTDY5afj6CkiQ+GU9kU3IF2wq157iS99P/ackA38PTXA4MBQxv7imjTyTiueZhO6Mh62MEuoG8sQNWZGegPcPX4GLZS9CXktgoWkfSgY5r/H2vB/8RCAiqddNO3YQI3FnHKfOHx85D3NJjQl9SFEUyS6NluoPSUI+fx88e4Zvvy9jRizmA45Z0Ch8GcPtMTgLTJYZAbvqXx2+BSjSambLXyyCVqNkZDPz513zxDNIhNyMqBQ+A8PthDy+ZGdJqz7XFj3uZCdJgbUftoPtiRMyBU+Ll2R6d5sTZhw9x9ni2dAMeCHu2Pwyi5nIgOUXc4xE/y0HWwh6BvICz7ZhIjDiGbQp62f1RrwSODjssiU7XQwcqyHgOrn9DvvIYTICz4uXZHp3lZBDxJVoyouc+av/NNmwCOFH5NkNWDebgcZhBAYnRbuNxvzgp8oHZ3LwUs8CHsy1pnSgGLCl+10pIWPVdYZfb8XdBB2Y8pWV4iEEHw6eDVjeca7FBtesmZ4ogvphI/60H0RhN2IuslaNPi4pvh+k9mAJwV+Ok27CJ7e/z6BztRP3wBB3wAnfvO3jG11X4TQfm9WgUi9UdxHA1nVjWu0zohvawUAzhODmH3RyeUuI74tFVP2kdGA3996L9bxaJDUM9rskJiY22kSR2Sxhk6bAb5tNgxhgf3fg5j6NaJVMr4tNnTL7PqHXTwTclW6CecFMKuxdHoc4KeTuSfxjiBlPqZmgMRhBD9znhxMKTIO6LiPDRQ7vhJK+mvylRQDgkF+abOBJMRugVSXXP6YyiuEOGSWg79KLkiby4X+/fRxUooBcwkekgyYa/AwwYC5CA9jBsxVeBjbBSJCOgE8A9KnelTe9NYf9nTPcFwlU+wgJEkhkM7rUXnTz+cQ/LzmNa95/R+PahQSZVcevQAAAABJRU5ErkJggg==")} />}
        },
        {
            field: 'cust_no',
            headerName: props.t('cust_no'),
            headerClassName: 'bold',
            minWidth: 75,
            width: 75,
            align: "left",
            display: "flex",
        },
        {
            field: 'cust_zone',
            headerName: props.t('zone'),
            headerClassName: 'bold',
            minWidth: 75,
            width: 75,
            align: "left",
            display: "flex",
        },
        {
            field: 'alt_name',
            headerName: props.t('name'),
            width: 200,
            align: "left",
            display: "flex",
        },
        {
            field: 'search_string',
            headerName: props.t('alt_name'),
            width: 200,
            align: "left",
            editable: true,
            display: "flex",
            renderEditCell: (params)=>{return <CustomEditComponent login={props.login} sql={"divers"} orig={params.row.search_string} user={props.userId} reload={()=>{props.loadCustomers();}} {...params}/>}
        },
        {
            field: 'cust_uses_api',
            headerName: "API",
            headerClassName: 'bold',
            headerAlign: 'center',
            minWidth: 42,
            maxWidth: 100,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return params.row.cust_uses_api ? <FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /> : <FontAwesomeIcon icon={faTimesCircle} color={Colors.def_red} size="2x" /> }
        },
        {
            field: 'cust_uses_birthday_sms',
            headerName: "Birthday SMS ",
            headerClassName: 'bold',
            headerAlign: 'center',
            minWidth: 42,
            maxWidth: 100,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return params.row.cust_uses_birthday_sms ? <FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /> : <FontAwesomeIcon icon={faTimesCircle} color={Colors.def_red} size="2x" /> }
        },
        {
            field: 'cust_uses_edi',
            headerName: "EDI ",
            headerClassName: 'bold',
            headerAlign: 'center',
            minWidth: 42,
            maxWidth: 100,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return params.row.cust_uses_edi ? <FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /> : <FontAwesomeIcon icon={faTimesCircle} color={Colors.def_red} size="2x" /> }
        },
        {
            field: 'cust_uses_eticket',
            headerName: "E-ticket",
            headerClassName: 'bold',
            headerAlign: 'center',
            minWidth: 42,
            maxWidth: 100,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return params.row.cust_uses_eticket ? <FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /> : <FontAwesomeIcon icon={faTimesCircle} color={Colors.def_red} size="2x" /> }
        },
        {
            field: 'cust_uses_rfid',
            headerName: "RFID ",
            headerClassName: 'bold',
            headerAlign: 'center',
            minWidth: 42,
            maxWidth: 100,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return params.row.cust_uses_rfid ? <FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /> : <FontAwesomeIcon icon={faTimesCircle} color={Colors.def_red} size="2x" /> }
        },
        {
            field: 'cust_uses_sft_webshop',
            headerName: "SFT Web ",
            headerClassName: 'bold',
            headerAlign: 'center',
            minWidth: 42,
            maxWidth: 100,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return params.row.cust_uses_sft_webshop ? <FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /> : <FontAwesomeIcon icon={faTimesCircle} color={Colors.def_red} size="2x" /> }
        },
        {
            field: 'encrypted_key',
            headerName: props.t('lic'),
            headerClassName: 'bold',
            headerAlign: 'center',
            minWidth: 42,
            maxWidth: 42,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return <div>{typeof params.row.encrypted_key !== "undefined" && (<Link to={"/"+props.lang+"/auth/"+params.row.encrypted_key+"/cookie"} style={{height: 38}} target="_blank" rel="noopener noreferrer"><img src={licenceIcon} width="28px" style={{marginTop: 5}} alt={"Licence module"}/>
        </Link>)}</div>}
        },

        
        
      ];
    const apiRef = useGridApiRef(); 
    
    
    useEffect(()=>{
        try{
            apiRef.current.subscribeEvent(
                'columnOrderChange',
                ()=>{visibilityChangedHandler();},
            );
        }catch(ex){
    
        }
    }, [apiRef]);

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    const visibilityChangedHandler = () => {
        let temp = apiRef.current.exportState();
        if(typeof temp.columns.columnVisibilityModel === "undefined"){
            temp.columns.columnVisibilityModel = {};
        }
        try{
            temp.preferencePanel.open = false;
        }catch(e){
    
        }
        try{
            delete temp.pagination;
        }catch(e){
            console.error(e);
        }
        setCookie("initialStateCustomers", JSON.stringify(temp), 100000);
    }


    function DataGrid() {
        return (
          <div>
            <DataGridPro
                apiRef={apiRef}
                className={props.theme}
                initialState={props.initialGrid}
                columns={gridColumns}
                onColumnWidthChange={()=>{visibilityChangedHandler();}}
                onColumnVisibilityModelChange={()=>{visibilityChangedHandler();}}
                onPreferencePanelClose={()=>{visibilityChangedHandler();}}
                rows={props.data.filter(row => (row.cust_no?.match(new RegExp(searchValue, "i")) || row.alt_name?.match(new RegExp(searchValue, "i")) || row.search_string?.match(new RegExp(searchValue, "i"))))
                .map((row) => {return {
                        id: row.cust_no + row.cust_zone + row.db_id,
                        cust_no: row.cust_no,
                        cust_zone: row.cust_zone,
                        encrypted_key: row.encrypted_key,
                        alt_name: row.alt_name,
                        search_string: row.search_string,
                        cust_uses_api: row.cust_uses_api,
                        cust_uses_eticket: row.cust_uses_eticket,
                        cust_uses_mailchimp: row.cust_uses_mailchimp,
                        cust_uses_rfid: row.cust_uses_rfid,
                        cust_uses_birthday_sms: row.cust_uses_birthday_sms,
                        cust_uses_edi: row.cust_uses_edi,
                        cust_uses_sft_webshop: row.cust_uses_sft_webshop,
                        logo: row.logo
                    }
                })}
                rowHeight={38}
                style={{maxHeight: 500}}
                pagination={true}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[10, 20, 30]}
                />
          </div>
        );
    }
    
    return (
        <div>
            <div className='log__container_options'>
                <TextField
                id="input-with-icon-textfield"
                autoComplete="off" 
                className={props.theme+ '_accent margin_right__10px'}
                sx={{ borderRadius: 3, marginTop: 0 }}
                size={'small'}
                fullWidth
                type="search"
                placeholder={props.t('search')}
                onChange={(e) => setSearchValue(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{color: Colors.sft_blue}} />
                    </InputAdornment>
                  ),
                }}
               />
            </div>

            
            {DataGrid()}
        </div>
    );
}

export default CustomersTable;